function getRemValue(valueInPx) {
    return `${valueInPx / 16}rem`;
}

export { getRemValue };
//# sourceMappingURL=getRemValue.js.map
